import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { QuoteBox } from './quote-box';
import 'bootstrap/dist/css/bootstrap.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <QuoteBox></QuoteBox>
    

);
console.log(3)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vital